import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path d="M8 6H11V22H13V6H16L12 2L8 6Z" xmlns="http://www.w3.org/2000/svg" />,
  "SmallLongUp"
);
